<app-title-bar rootBreadCrumbs="['i18n.core.navigation.import-configuration']"
  titleText="i18n.core.navigation.globalConfigurations"></app-title-bar>
<div class="row">
  <div class="col-4">
    <div class="row">
      <div class="col-12">
        <ejs-grid #grid rowHeight="38" class="grid-with-toolbar grid-configuration" [dataSource]="data"
          [allowSorting]="true" [allowPaging]="true" [pageSettings]='pageSettings' [allowFiltering]="true"
          [filterSettings]="filterSettings" (rowSelected)="onRowSelected($event)" (dataBound)="dataBound()">
          <ng-template #toolbarTemplate let-data>
            <ejs-toolbar>
              <e-items>
                <e-item [text]="'i18n.domain.import-configuration.add' | translate" prefixIcon='e-icons icon-add'
                  (click)="addConfiguration()" [disabled]="!addAllowed"></e-item>
                <e-item [text]="'i18n.domain.import-configuration.duplicate' | translate"
                  prefixIcon='e-icons icon-popup' (click)="duplicateConfiguration()"
                  [disabled]="configuration === null || configuration.id === null || configuration.id === 0"></e-item>
                <e-item [text]="'i18n.domain.import-configuration.create-from-template' | translate"
                  prefixIcon='e-icons icon-template' (click)="openTemplateDialog()"></e-item>
              </e-items>
            </ejs-toolbar>
          </ng-template>
          <e-columns>
            <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
            <e-column field="configurationName" headerText="{{'i18n.domain.import-configuration.name' | translate}}"
              clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                {{data.configurationName}} - {{getTransferTypeName(data.transferType) | translate}} ({{data.id}})
              </ng-template>
            </e-column>
            <e-column field="importType" headerText="{{'i18n.domain.import-configuration.import-type' | translate}}"
              clipMode="EllipsisWithTooltip" [filter]="checkBoxFilter" [allowSorting]='false'>
              <ng-template #filterItemTemplate let-data>{{formatFilterImportType(data)}}</ng-template>
              <ng-template #template let-data>
                {{'i18n.domain.import-configuration.enums.import-type.' + ImportType[data.importType] | translate}}
              </ng-template>
            </e-column>
            <e-column width="100" [headerText]="'i18n.domain.import-configuration.active' | translate" field="isActive">
              <ng-template #filterItemTemplate let-data>{{formatIsActive(data)}}</ng-template>
              <ng-template #template let-data>
                @if(data.isActive){
                  <div class="e-icons icon-checkmark align-middle"></div>
                }
              </ng-template>
            </e-column>
            <e-column width="30">
              <ng-template #template let-data>
                <div class="e-icons {{getNavisionTempalteIcon(data)}}"
                  [title]="'i18n.domain.import-configuration.edit.general.navision-template' | translate"></div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
  <div class="col-8">
    @if(configuration$ | async; as config) {
      <app-import-configuration-edit-forms [configuration]="config" [settings]="configurationEditSettings" [canEdit]="true" (save)="onSaveConfiguration($event)"
        (delete)="onDelete($event)" (cancel)="onCancel()"></app-import-configuration-edit-forms>
    }
  </div>
</div>

<ejs-dialog #loadTemplateDialog [isModal]="true" [showCloseIcon]="true" [visible]="false"
  (close)="onTemplateCancelClicked()">
  <ng-template #header>
    {{'i18n.domain.export-configuration.configurations.forms.email.template-selector-title' | translate}}
  </ng-template>

  <ng-template #content>
    <app-import-configuration-templates #configTemplateOverview (rowDoubleClick)="templateSelectedAndClose($event)"
      (rowSelected)="onTemplateSelected($event)">
    </app-import-configuration-templates>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-primary e-flat" (click)="onTemplateOkClicked()"
        [disabled]="!(selectedTemplate$ | async)">{{'i18n.shared.ok' | translate}}</button>
      <button class="e-control e-btn e-lib e-flat" (click)="onTemplateCancelClicked()">{{'i18n.shared.cancel' |
        translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
